import auth from '../../middlewares/auth';

export const leaveRoutes = [
  {
    path: '/leaves/all',
    component: () =>
      import(/* webpackChunkName: "leave" */ '../../views/leaves/LeaveList'),
    name: 'leaves-all',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/leaves/calendar',
    component: () =>
      import(
        /* webpackChunkName: "leave" */ '../../views/leaves/LeaveCalender'
      ),
    name: 'leaves-calender',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/leave/:id',
    component: () =>
      import(/* webpackChunkName: "leave" */ '../../views/leaves/LeaveForm'),
    name: 'update-leave',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/create-leave',
    component: () =>
      import(/* webpackChunkName: "leave" */ '../../views/leaves/LeaveForm'),
    name: 'create-leave',
    meta: {
      middleware: [auth],
    },
  },
];
